export function isFalsy(value: any) {
	return (
		value === null ||
		value === undefined ||
		value === 0 ||
		(typeof value === "object" && Object.keys(value).length === 0)
	);
}

export function isNull(value: any) {
	return value === null || value === undefined;
}

export function isFalsyAndNotZeroOrNegative(value: any) {
	if (!value || value < 0) {
		return false;
	}
	return true;
}

export function isNotNullUndefinedOrStringEmptyAndGreaterThanOrEqualToZero(value: any) {
	const it = String(value);
	const isValidString = typeof it === "string" && it.length > 0;
	if (isValidString && Number(it) >= 0) {
		return true;
	}

	return false;
}
